import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getInformationCatalogsDiscounts, createDiscount, updateDiscount, deleteDiscount } from '../../services/discounts/discounts';
import { validarSesion } from '../tokens/useToken';
import { sendRequest } from '../requests/useRequest';
import { useHistory } from 'react-router-dom';


export const useCatalogDiscountExams = () => {

    const history = useHistory();

    const [createSweet] = useSweetAlert();

    const [listTestDiscounts, setListTestDiscounts] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentExam, setCurrentExam] = useState(null);
    const [search, setSearch] = useState("");

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [method, setMethod] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);
    const [searchDiscount, setSearchDiscount] = useState("");


    // const toggle = () => {
    //     setModal(!modal);
    // }

    const openDialog = (title, mode) => {
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const [formValues, handleInputChange] = useForm({ mode: false });



    const { enable_discounts } = formValues;

    const handleGetTestDiscounts = async (search = "") => {
        setLoading(true);

        let listTmp = await handleRequest("GET", `EnableDiscountTests/List?search=${search}`, "Exámenes y perfiles");

        if (listTmp !== null && listTmp.length > 0) {
            const list = listTmp.map(obj => ({
                id_exam: obj.id_exam,
                id_profile: obj.id_profile,
                code: obj.code,
                name: obj.name,
                enable_discounts: obj.enable_discounts
            }));

            setListTestDiscounts(list);
            setDiscountExamData(list);
            // handleSaveDiscount(list);
        }

        setLoading(false);
    };


    useEffect(() => {
        handleGetTestDiscounts(search);
    }, [search]);


    const handleDiscountTestExam = (examData) => {
        setCurrentExam(examData);
        setMethod("update");

        handleInputChange({
            target: {
                name: "enable_discounts",
                value: examData.enable_discounts,
                type: "checkbox",
                checked: examData.enable_discounts
            }
        });

        openDialog("Editar descuento", "update");
    };


    const handleSaveDiscount = async () => {


        console.log("por aca pasa.........");


        const body = {
            id_exam: currentExam?.id_exam || null,
            id_profile: currentExam?.id_profile || null,
            mode: enable_discounts,
        };

        console.log("🚀 ~ handleSaveDiscount ~ body:", body);

        const result = await handleRequest("POST", "EnableDiscountTests/ChangeMode", "Guardar descuento", body);
        console.log("🚀 ~ handleSaveDiscount ~ result:", result);

        if (result !== null) {
            createSweet("success", "success", "Descuento", "Se guardó correctamente");
            closeDialog();
            handleGetTestDiscounts();
        } else {
            console.error("Error al guardar el descuento");
        }
    };



    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 409) { // Añadiendo el manejo de error 409
            createSweet("warning", "warning", nameMethod, "Este médico ya existe.");
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }


    // ? SEARCH TYPE DISCOUNT


    const [DiscountExamData, setDiscountExamData] = useState([]);
    const handleSearch = (e) => {
        setSearchDiscount(e)

        let busqueda = e.toUpperCase();
        let newDiscountExam = [];

        DiscountExamData.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newDiscountExam.push(element);
            }
        });
        setListTestDiscounts(newDiscountExam);
    }

    const handleClearDiscountExam = () => {
        setSearchDiscount("");
        localStorage.removeItem("globalFilter");
        setListTestDiscounts(DiscountExamData);
    };

    const handleExportExcelDiscount = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = listTestDiscounts.map((item, index) => ({
                "#": index + 1,
                Examen: item.name ?? "---",
                Descuento: item.enable_discounts ? "Sí" : "No",

            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Descuentos_examenes");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Decuentos_examenes.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };




    return {

        // * LIST
        listTestDiscounts,

        //* Modal 
        handleDiscountTestExam, modal, method, handleInputChange, enable_discounts, currentExam,

        handleSaveDiscount, setSearch, search, loading,

        loadingExport, handleExportExcelDiscount, handleClearDiscountExam, handleSearch,

        searchDiscount, closeDialog



    }
}
